import React, { useRef, useState, useEffect } from 'react'
import { COLOR_NAME } from '../../../constants'
import DynamicColor from '../../common/dynamic-color'

const Dropdown = props => {
    const {
        toggleButton,
        children,
        dropdownClass = '',
        dropdownListClass = '',
        widthFull,
        position = 'left top',
        forceClickOpen,
    } = props
    const [isOpen, setIsOpen] = useState(false)
    const wrapperRef = useRef(null)
    const listRef = useRef(null)

    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        if (wrapperRef) {
            if (isOpen) {
                document.addEventListener('mousedown', handleClickOutside)
            } else {
                document.removeEventListener('mousedown', handleClickOutside)
            }
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [wrapperRef, isOpen])

    const toggleShow = e => {
        e.stopPropagation()

        if (listRef.current && listRef.current.contains(e.target)) {
            return setIsOpen(false)
        }

        setIsOpen(old => forceClickOpen || !old)
    }

    const positions = position.split(' ')

    const dropdownListClasses = [
        'app-dropdown__list',
        dropdownListClass,
        widthFull ? 'width-full' : '',
        `list-position-${positions[0] || 'left'}`,
        positions[1] ? `list-align-${positions[1]}` : '',
    ].join(' ')

    return (
        <div
            ref={wrapperRef}
            onClick={toggleShow}
            className={`app-dropdown ${dropdownClass}`}
        >
            {toggleButton}
            {isOpen && (
                <DynamicColor
                    style={{ backgroundColor: COLOR_NAME.BODY_BG }}
                    ref={listRef}
                    className={dropdownListClasses}
                >
                    {children}
                </DynamicColor>
            )}
        </div>
    )
}

export default Dropdown
